module.exports = __webpack_public_path__ + "img/dashboard-img.354076d7.svg";